







































































import {Component, Prop, Ref, Vue} from 'vue-property-decorator';
import TextInput from '../../components/form/TextInput.vue';
import RadioButtonGroup from "../../components/form/RadioButtonGroup.vue";
import {SelectOption} from "../../components/form/types";
import {ValidationObserver, ValidationProvider} from 'vee-validate';
import {initializeValidators} from "../../utils/validators";
import {addUser} from "../../utils/shop/http-services";
import {defaultRegistrationFormData, RegistrationFormData} from "./types";

@Component({components: {RadioButtonGroup, TextInput, ValidationObserver, ValidationProvider}})
export default class GSRegistrationWidget extends Vue {
  @Prop() csrftoken!: string;
  @Ref() validator!: typeof ValidationObserver;

  beforeCreate(): void {
    initializeValidators(this.$i18n.locale);
  }

  $refs!: {
    messageField: HTMLElement
  }

  error: string | null = null;
  form: RegistrationFormData | null = null;
  registerInProgress = false;

  successMessage: string | null = null;

  salutationOptions: SelectOption[] = [
    {value: 'female', label: 'Frau'},
    {value: 'male', label: 'Herr'},
  ];

  created() {
    this.form = defaultRegistrationFormData;
  }

  async createCustomer() {
    if (this.registerInProgress) return;
    const valid = await (this.validator as any).validate();
    if (!valid) return;
    this.registerInProgress = true;
    addUser(this.csrftoken, this.mapToFormData())
    .then(response => {
      if (response.data.errors) {
        this.error = "";
        for (let errorKey in response.data.errors) {
          if (errorKey === "username" || errorKey === "unverifiedEmail") continue;
          this.error += '<p class="mb-3">' + response.data.errors[errorKey] + '</p>';
          this.successMessage = null;
        }
      } else {
        this.error = null;
        this.successMessage = "Wir haben Ihre Daten erhalten und melden uns in Kürze bei Ihnen.";
      }
    })
    .catch(ex => {
      console.error('Error', ex);
      this.successMessage = null;
      this.error = "Es gab einen Fehler bei der Registrierung. Versuchen Sie es nochmals oder kontaktieren Sie uns direkt.";
    }).finally(() => {
      this.registerInProgress = false;
      this.$refs.messageField.scrollIntoView({behavior: "smooth", block: "center"});
    });
  }

  mapToFormData(): FormData {
    const formData = new FormData();

    formData.append('email', this.form?.email || '');
    formData.append('username', this.form?.email || '');
    formData.append('firstName', this.form?.firstName || '');
    formData.append('lastName', this.form?.lastName || '');
    formData.append('fields[salutation]', this.form?.salutation?.label || '');
    formData.append('fields[company]', this.form?.company || '');
    formData.append('fields[phone]', this.form?.phone || '');
    formData.append('fields[mobile]', this.form?.mobile || '');
    formData.append('fields[uidField]', this.form?.uid || '');
    formData.append('fields[website]', this.form?.website || '');

    return formData;
  }
}
